module.exports = __webpack_public_path__ + "img/bn_side copy.df869b8e.jpg";